import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import FolderOpen from '@material-ui/icons/FolderOpen';
import CloudUpload from '@material-ui/icons/CloudUpload';

const AttachmentMenu = ({ anchorEl, open, onClose, onSelectFromLibrary, onSelectFromDevice }) => {
  const intl = useIntl();

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem
        onClick={() => {
          onClose();
          onSelectFromLibrary();
        }}
      >
        <ListItemIcon>
          <FolderOpen />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'conversations.attachFromLibrary',
            defaultMessage: 'From My files',
          })}
        />
      </MenuItem>
      <MenuItem
        onClick={() => {
          onClose();
          onSelectFromDevice();
        }}
      >
        <ListItemIcon>
          <CloudUpload />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'conversations.attachFromDevice',
            defaultMessage: 'Upload from device',
          })}
        />
      </MenuItem>
    </Menu>
  );
};

AttachmentMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectFromLibrary: PropTypes.func.isRequired,
  onSelectFromDevice: PropTypes.func.isRequired,
};

export default AttachmentMenu;
